import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;
const prefix = `/api/v2`;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchBook = bookId => {
    return axios.get(`${prefix}/books/${bookId}/`);
};

export const fetchEmptyParts = bookId => {
    return axios.get(`${prefix}/books/${bookId}/empty_parts/`);
};

export const fetchReplacements = (bookId, params) => {
    return axios.get(`${prefix}/books/${bookId}/replace_parts/`, { params });
};

export const replaceSinglePart = (bookId, data) => {
    return axios.put(`${prefix}/books/${bookId}/replace_single_part/`, data);
};

export const replaceAllParts = (bookId, data) => {
    return axios.put(`${prefix}/books/${bookId}/replace_all_parts/`, data);
};

export const searchBookpart = (bookId, query) => {
    return axios.get(`${prefix}/books/${bookId}/search/?search_part=${encodeURIComponent(query)}`);
};

export const multipleLinkage = (bookId, data) => {
    return axios.post(`${prefix}/books/${bookId}/multiple_linkage/`, data);
};

export const checkBooksQueue = bookId => {
    return axios.get(`${prefix}/books/${bookId}/in_queue/`);
};

export const fetchBookContents = bookId => {
    return axios.get(`${prefix}/books/${bookId}/contents/`);
};

export const fetchSectionsDuration = bookId => {
    return axios.get(`${prefix}/books/${bookId}/sections_duration/`);
};

export const exportBooks = (params = {}) => {
    return axios.get(`${prefix}/books/export/`, { responseType: 'blob', ...params });
};

export const getCurrentTiming = (id, params = {}) => {
    return axios.post(`${prefix}/books/${id}/current_timing/`, params);
};

export const fetchBookLanguages = () => {
    return axios.get(`${prefix}/books/book_languages/`);
};

// TODO MOVE TO OWN API FILE
export const fetchLanguages = (params = { page_size: 1000 }) => {
    return axios.get(`/api/v1/languages/languages/`, { params });
};

// TODO MOVE TO OWN API FILE
export const fetchPauseConfigs = async (params = { page: 1, page_size: 20 }) => {
    const url = '/api/v2/pause_configs/';
    const { results = [] } = await axios.get(url, { params });
    return results;
};

export const fetchCharInfo = (id, params = {}) => {
    return axios.get(`/api/v2/books/${id}/chars_info/`, { params });
};

export const generateCover = (id, params = {}) => {
    return axios.put(`/api/v2/books/${id}/generate_cover/`, { params });
};

export const patchBook = (id, data) => {
    return axios.patch(`/api/v2/books/${id}/`, data);
};

export const updateAuthors = (id, data) => {
    return axios.put(`/api/v2/books/${id}/authors/`, data);
};
